import { useState, useEffect, useRef } from "react";

import InputSearch from "/src/components/UI/InputSearch/InputSearch";

import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import ModalManager from "@ebay/nice-modal-react";

import IntegrationCodeLine from "../IntegrationCodeLine/IntegrationCodeLine";

import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import "/src/components/UI/Button/IconButton/IconButton.css";
import integrationService from "../../services/integrationService";
import { useNavigate } from "react-router-dom";
import "./IntegrationTable.css";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import hasPermission from "/src/utils/hasPermission";
import generateKey from "/src/utils/generateKey";
function IntegrationTableWorksheet({ searchKey, onKeyFound }) {
    const [integrations, setIntegrations] = useState([]);
    const [search, setSearch] = useState(searchKey || "");
    const [fetching, setFetching] = useState(false);
    const [param, setParam] = useState({ page: 1, filter: {} });
    const navigate = useNavigate();
    var integrationsListTotal = [];
    const foundKeyRef = useRef(false);
    const { getIntegrationsWorksheet, deleteIntegration } = integrationService;

    const getIntegrationsList = async () => {
        const { page, filters } = param;
        setFetching(true);
        let [response, error] = await getIntegrationsWorksheet({ page, term: search });
        if (error !== null) {
            console.log(error);
            return;
        }
        integrationsListTotal = integrations;
        for (let i = 0; i < response.data.length; i++) {
            let newIntegration = response.data[i];
            if (!integrations.some((integ) => integ.id === newIntegration.id)) {
                integrationsListTotal = [...integrationsListTotal, newIntegration];
            }
        }
        setIntegrations(integrationsListTotal);
        setFetching(false);

        if (searchKey && !foundKeyRef.current && response.data.some((integ) => integ.api_key === searchKey)) {
            foundKeyRef.current = true;
            onKeyFound && onKeyFound();
        }

        return response.data;
    };

    const onClickAdd = () => navigate(urlWithRoutingCompany("/plugin/integrations/create"));

    const onClickDelete = async (integration) => {
        await ModalManager.show(ApiModal, {
            title: "Delete Integration " + integration.name,
            body: "Do you really want to delete Integration " + integration.name,
            api: {
                request: deleteIntegration,
                param: [integration.id],
            },
            buttons: [
                { className: "validate", label: "Cancel" },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
        });
        setIntegrations((current) =>
            current.filter((obj) => {
                return obj.id !== integration.id;
            })
        );
    };

    const onScroll = (e) => {
        const { scrollHeight, scrollTop, clientHeight } = e.target;
        if (scrollHeight - scrollTop - clientHeight > 40) {
            return null;
        }
        addPage();
    };

    useEffect(() => {
        document.getElementsByClassName("page")[0].addEventListener("scroll", onScroll);

        return () => {
            var page = document.getElementsByClassName("page")[0];
            if (page) {
                document.getElementsByClassName("page")[0].removeEventListener("scroll", onScroll);
            }
        };
    }, [fetching]);

    const research = async (_search) => {
        integrationsListTotal = [];
        setSearch(_search);
        setParam({ page: 1, filters: {} });
        let [response, error] = await getIntegrationsWorksheet({ page: 1, term: _search });
        if (error !== null) {
            console.log(error);
            return;
        }
        setIntegrations(response.data);
    };

    useEffect(() => {
        getIntegrationsList();
    }, [param.page]);

    const addPage = () => {
        if (fetching == true) {
            return;
        }

        setParam({ page: param.page + 1, filter: param.filter });
    };

    return (
        <div onScroll={(e) => onScroll(e)}>
            <br />
            <br />
            <div style={{ display: "flex" }} className="up_row-integrations">
                <div className="input_integrations_container">
                    <div className="input_integrations">
                        <InputSearch
                            placeholderLibelle="content"
                            defaultValue={searchKey}
                            onChange={(e) => research(e.target.value)}></InputSearch>
                    </div>
                </div>
                <div className="add_button_container">
                    <div>
                        {hasPermission("create_integration") ? (
                            <IconButton
                                onClick={(e) => onClickAdd()}
                                icon={"fas fa-plus"}
                                className="main-iconButton profil_action main_add-button"></IconButton>
                        ) : null}
                    </div>
                </div>
            </div>

            <div className="integrations_table_container">
                {Array.isArray(integrations) &&
                    integrations.map((integration, i) => {
                        let value = integration.api_key + "&question=Hello";
                        return (
                            <IntegrationCodeLine
                                key={generateKey()}
                                integration={integration}
                                text={value}
                                handleDelete={onClickDelete}
                                api_key={integration.api_key}
                            />
                        );
                    })}
            </div>
        </div>
    );
}

export default IntegrationTableWorksheet;
